var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "elevation-1",
      staticStyle: { position: "relative" },
      attrs: { id: "map", type: "light", oncontextmenu: "return false" }
    },
    [
      _c("center-location-button", {
        attrs: {
          disabled: !_vm.assetReservationFeature,
          viewIsAerial: _vm.isAerial
        },
        on: { click: _vm.centerOnAssetReservationArea }
      }),
      _vm._v(" "),
      _c("change-map-type-button", {
        attrs: { viewIsAerial: _vm.isAerial },
        on: { click: _vm.changeViewType }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8be9c11e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8be9c11e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Data/ReservationDetailsMap.vue
// module id = null
// module chunks = 